import helperFunctions from "./helper-functions";
import majorityModel from "@/store/orm-axios/models/Majority";
let eventSource;

const majorityIRI = "/majorities/";

export default {
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initMajoritiesMercure();
      }
    },
  },
  created() {
    this.initMajoritiesMercure();
  },
  destroyed() {
    eventSource.close();
  },
  methods: {
    async initMajoritiesMercure() {
      if (!this.isAuthenticatedForMercure && this.isDesktop) {
        await helperFunctions.loginWebFromDesktop();
      }

      if (eventSource) eventSource.close();

      const topics = [`${majorityIRI}{id}`];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(majorityIRI)) {
          model = majorityModel;
        }

        helperFunctions.modifyInStore(eventData, model);
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
